import React from 'react';

import cx from 'classnames';
import ReactTooltip from 'react-tooltip';

import CheckBox from 'components/shared/FormAdapters/FormDefault/CheckBox';
import Icon from 'components/shared/Icon';
import Trash from 'components/shared/Icon/icons/Trash';
import tableStyles from 'components/shared/Table/index.module.css';

import s from './index.module.css';

function Item(props) {
  const { font, onCheck, checked, onRemove } = props;
  const { policies, id } = font;
  const destroy = policies?.destroy;
  const noDestroyText = 'This font is being used elsewhere in Safari Portal and cannot be deleted';
  const btnClasses = cx(s.btn, 'btn-reset', !destroy && s.btnDisabled);

  return (
    <tr>
      <td className={cx(tableStyles.cell, tableStyles.cellTd, s.checkTd)}>
        <CheckBox onChange={() => onCheck(id)} checked={checked} noMargin size="sm" className={s.checkbox} />
      </td>
      <td className={cx(tableStyles.cell, tableStyles.cellTd)}>{font?.filename}</td>
      <td className={cx(tableStyles.cell, tableStyles.cellTd)}>{font?.fontFamily}</td>
      <td className={cx(tableStyles.cell, tableStyles.cellTd)}>{font?.fontStyle}</td>
      <td className={cx(tableStyles.cell, tableStyles.cellTd)}>{font?.fontWeight}</td>
      <td className={cx(tableStyles.cell, tableStyles.cellTd)}>
        <button
          type="button"
          className={btnClasses}
          data-tip={noDestroyText}
          data-for={`${font.id}`}
          onClick={() => {
            if (!destroy) return;
            onRemove(id);
          }}
        >
          <Icon component={Trash} className={s.icon} />
        </button>
        {!destroy && <ReactTooltip id={`${font.id}`} place="top" effect="solid" border type="light" />}
      </td>
    </tr>
  );
}

export default Item;
